/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useContext } from 'react';
import { useNavigate, Link } from "react-router";

import { useAuth } from '@/commons/auth';
import { Button, Detail, VisualizationAttr, Modal, Spinner } from '@/commons/components';

import deleteKelas from '../services/deleteKelas';
import deleteJadwalKelas from '../services/deleteJadwalKelas';
import deleteKelasDosen from '../services/deleteKelasDosen';

import * as Layouts from "@/commons/layouts";


const DetailKelas = ({ data }) => {
    const { checkPermission } = useAuth();
    const navigate = useNavigate();
    const [showModalKonfirmasiHapusKelas, setShowModalKonfirmasiHapusKelas] = React.useState(false); 
    const [showModalKonfirmasiHapusJadwalKelas, setShowModalKonfirmasiHapusJadwalKelas] = React.useState(false); 
    const [showModalKonfirmasiHapusDosenKelas, setShowModalKonfirmasiHapusDosenKelas] = React.useState(false); 
    const ubahKelas = async () => {
      navigate("/kelas/ubah?" + `id=${data.id}`);
    };
  
    const hapus = async () => {
      await deleteKelas({
        id: data.id,
      });
      navigate('/kelas');
    };
    const hapusJadwal = async () => {
      await deleteJadwalKelas({
        id: data.id,
      });
      navigate(`/kelas/${data.kelasId}`);
    };
    const hapusDosen = async () => {
      await deleteKelasDosen({
        id: data.id,
      });
      navigate(`/kelas/${data.kelasId}`);
    };
  
  return (
    <Layouts.DetailComponentLayout
      item={data}
      itemsAttrs={[
        {
          id: "nama",
          condition: "",
          label: "Nama",
          featureName: "nama",
        }
        ,
        {
          id: "kapasitas",
          condition: "",
          label: "Kapasitas",
          featureName: "kapasitas",
        }
        ,
        {
          id: "mataKuliah",
          condition: "",
          label: "Mata Kuliah",
          featureName: "mataKuliahNama",
        }
        ,
        {
          id: "semester",
          condition: "",
          label: "Semester",
          featureName: "semesterName",
        }
        
      ]}
      itemsEvents={[
            checkPermission("UpdateKelas") &&  (
              <Button
                id="_QvEzoJw4Ee-ejYgMQj2CMA"
                variant="secondary"
                onClick={() => ubahKelas()}
              >
                Ubah Kelas
              </Button>
            )
        ,
            checkPermission("DeleteKelas") &&  (
              <Button
                id="_sftMgJw5Ee-ejYgMQj2CMA"
                variant="tertiary"
                onClick={() => setShowModalKonfirmasiHapusKelas(true)}
              >
                Hapus
              </Button>
            )
        
      ]}
      itemsModals={[
        <>
        <Modal
           isShow={showModalKonfirmasiHapusKelas}
           title={"Konfirmasi Hapus Kelas"}
           text={"Are you sure want to proceed?"}
        >
           <Link to=''><Button variant="tertiary" onClick={() => setShowModalKonfirmasiHapusKelas(false)}>Batal</Button></Link>
          <Button
            id="_37Hf4Jw5Ee-ejYgMQj2CMA"
            variant="danger"
            onClick={() => hapus()}
          >
            Hapus
          </Button>
        </Modal>
        <Modal
           isShow={showModalKonfirmasiHapusJadwalKelas}
           title={"Konfirmasi Hapus Jadwal Kelas"}
           text={"Are you sure want to proceed?"}
        >
           <Link to=''><Button variant="tertiary" onClick={() => setShowModalKonfirmasiHapusJadwalKelas(false)}>Batal</Button></Link>
          <Button
            id="_v6jJQCwkEfCoct7gkgY0lg"
            variant="danger"
            onClick={() => hapusJadwal()}
          >
            Hapus
          </Button>
        </Modal>
        <Modal
           isShow={showModalKonfirmasiHapusDosenKelas}
           title={"Konfirmasi Hapus Dosen Kelas"}
           text={"Are you sure want to proceed?"}
        >
           <Link to=''><Button variant="tertiary" onClick={() => setShowModalKonfirmasiHapusDosenKelas(false)}>Batal</Button></Link>
          <Button
            id="_JkeXIC5REfCiIOe1nt4Q7w"
            variant="tertiary"
            onClick={() => hapusDosen()}
          >
            Hapus
          </Button>
        </Modal>
        </>
        
      ]}
    />
  );
};

export default DetailKelas;
